export const getLinkObject = (path, name, component, links, privilegeName) => {
  return {
    path,
    name,
    component,
    links,
    privilegeName
  }
}
